import React from "react";
import DatePicker from "./DatePicker";
import DateTimePicker from "./DateTimePicker";
var DateControl = function DateControl(props) {
  return window.appConfig.features.isNewDateUIEnabled ? React.createElement(DateTimePicker, Object.assign({}, props)) : React.createElement(DatePicker, Object.assign({}, props));
};
export default DateControl;